import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { createUrlExpander, UrlExpander } from './url-expander';

@Injectable({
  providedIn: 'root',
})
export class UrlExpanderService {
  private urlExpander: UrlExpander;

  constructor(@Inject(DOCUMENT) document: Document) {
    this.urlExpander = createUrlExpander(document.domain, document.location.port, {
      ssl: document.location.protocol === 'https:',
    });
  }

  expand(path: string, opts?: { excludeSSLPort: boolean }) {
    return this.urlExpander.expand(path, opts);
  }
}
